// reccarousal

const zoho="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Homepage_pics/zoho.webp"
//const zoho="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/about/home/zoho.webp"
const lt="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/about/home/lt.webp"
//const gofrugal="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/about/home/gofrugal.webp"
const whiteblue="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/about/home/whiteblue.webp"
export const reccarousal=[
  zoho,
  // hcl,
  lt,
  // wipro,
  // whiteblue
]